import { useCallback, useContext, useEffect, useSyncExternalStore } from 'react'
import type { ServiceSignal } from '../../api/client'
import { ServiceStatusContext } from './ServiceStatusProvider'
import type { ServiceStatusStore, StatusSnapshot } from './store'

const SWEEP_INTERVAL_MS = 30_000

const useStore = (): ServiceStatusStore => {
  const store = useContext(ServiceStatusContext)
  if (store === null) throw new Error('useServiceStatus 必須在 ServiceStatusProvider 內使用')
  return store
}

export const useServiceStatus = (): StatusSnapshot => {
  const store = useStore()

  useEffect(() => {
    const id = setInterval(() => store.sweep(), SWEEP_INTERVAL_MS)
    return () => clearInterval(id)
  }, [store])

  return useSyncExternalStore(store.subscribe, store.snapshot, store.snapshot)
}

export const useServiceStatusReporter = () => {
  const store = useStore()
  return useCallback((signal: ServiceSignal) => store.report(signal), [store])
}

export const useServiceStatusClear = () => {
  const store = useStore()
  return useCallback((kind: Parameters<ServiceStatusStore['clear']>[0]) => store.clear(kind), [store])
}

export const useServiceStatusSynced = () => {
  const store = useStore()
  return useCallback((at: string) => store.markSynced(at), [store])
}
